import { Container } from 'mdbreact'
import SingUpForm from '../../components/SignUpForm/SignUpForm'

const SignUpPage = () => {


    return (
        <>
            <Container>

                <SingUpForm />

            </Container>
        </>
    )
}


export default SignUpPage